import config from '../../../../config';

import orgInviteUrlModalUrl from './orgInviteUrlModal.html';

class OrgInviteUrlModalCtrl {
  constructor(SelfInviteService) {
    'ngInject';

    Object.assign(this, { SelfInviteService });
  }

  error = null;
  isLoading = false;

  $onInit() {
    this.loadSlug();
  }

  async loadSlug() {
    this.isLoading = true;
    try {
      const { slug } = await this.SelfInviteService.getInviteSlug();
      this.inviteUrl = `${config.SLING_LOGIN_URL}/register/request-join/${encodeURIComponent(
        slug
      )}`;
    } catch (e) {
      this.error = e;
    } finally {
      this.isLoading = false;
    }
  }
}

export default {
  templateUrl: orgInviteUrlModalUrl,
  controller: OrgInviteUrlModalCtrl,
  controllerAs: 'ctrl',
  bindings: {
    modalInstance: '<',
  },
};
